/**
 * Fills the current year in #year.
 */
export function setFooterYear() {
  const el = document.getElementById('year');
  if (el) {
    el.textContent = String(new Date().getFullYear());
  }
}
